import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantFlowsService } from '@app/core/services/tenant-flows.service';
import { AuthService } from './auth.service';

export const permissionGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const tenantFlows = inject(TenantFlowsService);
  const router = inject(Router);
  const denied = () =>
    router.createUrlTree(['/access-denied'], {
      queryParams: {
        redirect: state.url
      }
    });

  const requiredPermission = route.data['requiredPermission'] as string | string[] | undefined;
  if (requiredPermission && !authService.hasPermission(requiredPermission)) {
    return denied();
  }

  // Role gate para herramientas de plataforma. Es necesario además del
  // permiso porque hasPermission acepta scope O permiso, y los scopes son del
  // CLIENTE: la AAP concede `health` a todo usuario que entra por esta app,
  // así que el permiso solo no distingue MASTER de un manager de tenant.
  const requiredRole = route.data['requiredRole'] as string | string[] | undefined;
  if (requiredRole && !authService.hasRole(requiredRole)) {
    return denied();
  }

  // Flow gate: a manager only reaches pages of the flows its tenant contracted.
  const requiredFlows = route.data['requiredFlows'] as string[] | undefined;
  if (requiredFlows) {
    await tenantFlows.ensureLoaded();
    if (!tenantFlows.allowsAny(requiredFlows)) {
      return denied();
    }
  }

  // Capacidad de notificaciones: mismo gate que el menú, para que el deep link
  // no sea una puerta trasera.
  if (route.data['requiresNotifications']) {
    await tenantFlows.ensureLoaded();
    if (!tenantFlows.allowsNotifications()) {
      return denied();
    }
  }

  return true;
};
